import { isSameRow } from '../utils/is-same-row'
import { syncCurrentRowDom } from '../utils/sync-current-row-dom'
import type { DataGrid } from '../types'

export function useRow($grid: DataGrid) {
  $grid.setCurrentRow = (row, options) => {
    const prevRow = $grid.reactData.currentRow
    if (isSameRow(prevRow, row)) {
      return
    }
    syncCurrentRowDom($grid, prevRow, row)
    $grid.reactData.currentRow = row
    if (!options?.silent) {
      $grid.options.onCurrentRowChange?.(row)
    }
  }

  $grid.syncCurrentRowDom = () => {
    const current = $grid.reactData.currentRow
    syncCurrentRowDom($grid, null, current)
  }
}
